module.exports = __webpack_public_path__ + "cf.svg?e0c7df8026c2f123e1431764a1f53c6e";